export default __webpack_public_path__ + "static/hompagePic-7a41f411b38bab617c9bab0fd9f90c5f.jpg";